module.exports = __webpack_public_path__ + "img/MeterWorkOrders-Field.f5ba0d28.png";